import styles from './index.module.scss';
import { Button } from '@bfe/moly';
import cls from 'classnames';
import Tg from '@/assets/svg/detail/tg.svg';
import Twitter from '@/assets/svg/detail/twitter.svg';
import RedBubble from '@/assets/svg/detail/red.svg';
import GreenBubble from '@/assets/svg/detail/green.svg';
import YellowBubble from '@/assets/svg/detail/yellow.svg';
import { useFm, useParams } from '@web3/base-hooks';
import { EntityListResp, SupportStatus } from '@/types/home';
import { appPath } from '@web3/base-utils';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';
import { formatNumber } from '@web3/base-utils';

const Row = ({
  label,
  value,
  rowClassName = '',
  labelClassName = '',
  valueClassName = '',
}) => {
  return (
    <div className={cls(styles.row, rowClassName)}>
      <div className={cls(styles.label, labelClassName)}>{label}</div>
      <div className={cls(styles.value, valueClassName)}>{value}</div>
    </div>
  );
};

export const AnalysisDetail = ({
  curEntity,
}: {
  curEntity: EntityListResp;
}) => {
  const fm = useFm();
  const { locale } = useParams();

  const support = {
    [SupportStatus.BEING_TRACKED]: {
      color: '#20B26C',
      bgColor: 'rgba(32, 178, 108, 0.16)',
      text: fm('tracking'),
    },
    [SupportStatus.PENDING_INFO]: {
      color: '#EF454A',
      bgColor: 'rgba(239, 69, 74, 0.16)',
      text: fm('pendingInfo'),
    },
    [SupportStatus.PROVIDE_INFO]: {
      color: '#20B26C',
      bgColor: 'rgba(32, 178, 108, 0.16)',
      text: fm('providedInfo'),
    },
    [SupportStatus.PROVIDE_NEXT_DEST]: {
      color: '#20B26C',
      bgColor: 'rgba(32, 178, 108, 0.16)',
      text: fm('providedNextDest'),
    },
    [SupportStatus.FROZEN]: {
      color: '#20B26C',
      bgColor: 'rgba(32, 178, 108, 0.16)',
      text: fm('frozen'),
    },
    [SupportStatus.ALL_LOST]: {
      color: '#EF454A',
      bgColor: 'rgba(239, 69, 74, 0.16)',
      text: fm('allLost'),
    },
  };

  // 计时暂时不做，逻辑先备注，以免后续又要添加
  // useEffect(() => {
  //   if (timer.current) {
  //     clearInterval(timer.current);
  //   }

  //   if (
  //     curEntity?.awaitingResponseTime &&
  //     Number(curEntity?.awaitingResponseFund) > 0 &&
  //     (curEntity?.supportStatus === SupportStatus.NO_RESP ||
  //       curEntity?.supportStatus === SupportStatus.REJECT_PROVIDE ||
  //       curEntity?.supportStatus === SupportStatus.PARTIAL_SUPPORT)
  //   ) {
  //     const currentUTC = dayjs.utc();
  //     let timeDiff = currentUTC.diff(dayjs(curEntity?.awaitingResponseTime));

  //     timer.current = setInterval(() => {
  //       timeDiff = timeDiff + 1000;
  //       setCurrentTimeDiff(timeDiff);
  //     }, 1000);
  //   }

  //   return () => {
  //     clearInterval(timer.current);
  //   };
  // }, [curEntity]);
  const showAwaitingResponseTime =
    Number(curEntity?.unblocked) > 0 &&
    curEntity?.awaitingResponseTime &&
    curEntity?.awaitingResponseTime !== 'N/A';

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.top}>
          <div className={styles.info}>
            <div className={styles.name}>{curEntity?.name}</div>
            <div
              className={styles.support}
              style={{
                color: support[curEntity?.supportStatus]?.color ?? '#EF454A',
                backgroundColor:
                  support[curEntity?.supportStatus]?.bgColor ??
                  'rgba(32, 178, 108, 0.16)',
              }}
            >
              {support[curEntity?.supportStatus]?.text ?? ''}
            </div>
          </div>
          <div className={styles.logo}>
            {curEntity?.tgUrl && (
              <Tg
                className={styles.tg}
                onClick={() => {
                  window.open(curEntity?.tgUrl, '_blank');
                }}
              />
            )}
            {curEntity?.twitterUrl && (
              <Twitter
                className={styles.twitter}
                onClick={() => {
                  window.open(curEntity?.twitterUrl, '_blank');
                }}
              />
            )}
          </div>
        </div>

        {Number(curEntity?.unblocked) > 0 && (
          <Row
            label={fm('fundAwaitResponse')}
            value={`$${formatNumber(curEntity?.unblocked, { kmb: false, placeholder: '0', decimal: 0, noTrailZero: true })}`}
          />
        )}
        <Row
          label={fm('blockedFunds')}
          value={`$${formatNumber(curEntity?.blocked, { kmb: false, placeholder: '0', decimal: 0, noTrailZero: true })}`}
        />
        <Row
          label={fm('lostFunds')}
          rowClassName={
            showAwaitingResponseTime ? '' : styles.noResponseTimeRow
          }
          value={`$${formatNumber(curEntity?.lostFund, { kmb: false, placeholder: '0', decimal: 0, noTrailZero: true })}`}
        />
        {showAwaitingResponseTime && (
          <Row
            label={fm('nonResponseTime')}
            value={curEntity?.awaitingResponseTime}
            rowClassName={styles.noResponseTimeRow}
          />
        )}

        <div className={styles.gap} />
        <Row
          label={fm('actionedUnresponded')}
          value={`${curEntity?.bannedAddressCount ?? 0} /
              ${
                Number(curEntity?.reportedAddressCount ?? 0) -
                Number(curEntity?.bannedAddressCount ?? 0)
              }`}
        />
        <Row label={fm('contributors')} value={curEntity?.contributors ?? 0} />
        <Row
          label={fm('totalEstimatedBountyRewards')}
          value={`$${formatNumber(curEntity?.estimatedBountyAmount, { kmb: false, placeholder: '0', decimal: 0, noTrailZero: true })}`}
          rowClassName={styles.totalEstaimedRow}
        />

        <div className={styles.gap} />

        <Row
          label={fm('nonResponseTime')}
          value={fm('fundAwaitResponse')}
          labelClassName={styles.roleLable}
          valueClassName={styles.roleValue}
        />

        <Row
          rowClassName={styles.bubbleRow}
          labelClassName={styles.bubbleLabel}
          label={
            <div className={styles.bubbleLeft}>
              <GreenBubble className={styles.bubble} />
              <p>{'<1D'}</p>
            </div>
          }
          value={`$${formatNumber(curEntity?.blockList?.[0]?.amount ?? 0, { kmb: false, placeholder: '0', decimal: 0, noTrailZero: true })}`}
        />
        <Row
          rowClassName={styles.bubbleRow}
          labelClassName={styles.bubbleLabel}
          label={
            <div className={styles.bubbleLeft}>
              <YellowBubble className={styles.bubble} />
              <p>{'1D-2D'}</p>
            </div>
          }
          value={`$${formatNumber(curEntity?.blockList?.[1]?.amount ?? 0, { kmb: false, placeholder: '0', decimal: 0, noTrailZero: true })}`}
        />
        <Row
          rowClassName={styles.specialRow}
          labelClassName={styles.bubbleLabel}
          label={
            <div className={styles.bubbleLeft}>
              <RedBubble className={styles.bubble} />
              <p>{'>2D'}</p>
            </div>
          }
          value={`$${formatNumber(curEntity?.blockList?.[2]?.amount ?? 0, { kmb: false, placeholder: '0', decimal: 0, noTrailZero: true })}`}
        />

        <Row
          label={fm('role')}
          value={fm('rewards')}
          rowClassName={styles.roleRow}
          labelClassName={styles.roleLable}
          valueClassName={styles.roleValue}
        />
        <Row
          label={fm('bountyHunter')}
          value={`${curEntity?.firstReporter ?? 0}%`}
          rowClassName={styles.firstReporRow}
          labelClassName={styles.firstReportName}
          valueClassName={styles.firstReportValue}
        />
        <Row
          label={fm('freezer')}
          value={`${curEntity?.resiResipient ?? 0}%`}
          labelClassName={styles.ResipientName}
          valueClassName={styles.ResipientValue}
        />
      </div>
      <div className={styles.bottom}>
        <Button
          variant="primary"
          size="large"
          className={styles.btn}
          onClick={() => {
            scTrack(Event.HackbountyUserClick, {
              page_name: Page.HackbountyHomePage,
              button_name: 'NodeSumbit',
            });

            window.open(`/${locale}${appPath}/report`, '_blank');
          }}
        >
          {fm('submitBounty')}
        </Button>
        <Button
          variant="secondaryBrand"
          size="large"
          className={cls(styles.btn, styles.viewMore)}
          onClick={() => {
            scTrack(Event.HackbountyUserClick, {
              page_name: Page.HackbountyHomePage,
              button_name: 'NodeSumbit',
            });

            window.open(
              `/${locale}${appPath}/detail?entity=${curEntity?.name}`,
              '_blank'
            );
          }}
        >
          {fm('viewMore')}
        </Button>
      </div>
    </div>
  );
};
